import * as Sentry from '@sentry/nuxt'

declare const APP_NAME: string
declare const APP_VERSION: string

Sentry.init({
  dsn: process.env.SENTRY_DSN,
  environment: process.env.NUXT_APP_ENVIRONMENT,
  release: `${APP_NAME}@${APP_VERSION}`,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
    Sentry.browserProfilingIntegration(),
  ],
  tracesSampleRate: 1.0,
  tracePropagationTargets: [/^https:\/\/dmat\.(dev|api)\.comfortfinancegroup\.com/],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  profilesSampleRate: 1.0,
})
